/* eslint-disable */
import _ from 'lodash';

import * as types from '../actions/types';
import { FETCH_UMKLIST_DATA_COMPLETED } from "../actions/types";

const initialState = {
  umk: {},
  group: {},
  disciplineList: [],
  isLoading: false,
  curriculum: [],
  disciplines: [/* { value: 0, name: 'Все', label: 'Все' } */],
  courses: [{ value: 0, name: 'Все', label: 'Все' }],
  umkList: [],
  umkCard: {},
  umkContentData: [],
  umkTypeData: false
};

export default function umk(state = initialState, action) {
  switch (action.type) {
    case types.UMK_FETCH_STARTED:
    case types.FETCH_UMKLIST_DATA_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.UMK_FETCH_COMPLETED:
      return {
        ...state,
        umk: action.umk,
        group: {
          schoolYear:
            action.umk.syid.studyYear[0].school_year.schoolYear[0].name,
          syid: action.umk.syid.studyYear[0].syid,
          specialization:
            action.umk.f_militaryprofession &&
            action.umk.f_militaryprofession.militaryProfession[0]
              .specialization,
          name: action.umk.name,
          militaryProfession:
            action.umk.f_militaryprofession &&
            action.umk.f_militaryprofession.militaryProfession[0]
              .name,
          educationPlan:
            action.umk.educationplan &&
            action.umk.educationplan.educationplanname,
          educationPlanId:
            action.umk.educationplan &&
            action.umk.educationplan.educationplanid,
          year: action.umk.year,
        },
      };
    case types.DISCIPLINE_LIST_FETCH_COMPLETED:
      const disciplineList = [];
      _.forOwn(action.disciplineList, (value, key) =>
        disciplineList.push({ cours: key, list: value })
      );
      return {
        ...state,
        disciplineList,
        isLoading: false,
      };
    case types.FETCH_CIRRICULUM_COMPLETED:
      return {
        ...state,
        curriculum: [
          // { value: 0, name: 'Все', label: 'Все' },
          ...action.payload.map(a => ({
            value: a.idcurriculum,
            name: a['Название'],
            label: a['Название'],
          })),
        ],
      };
    case types.FETCH_DISCIPLINES_COMPLETED:
      return {
        ...state,
        disciplines: [
          // { value: 0, name: 'Все', label: 'Все' },
          ...action.payload.map(a => ({
            value: a.cid,
            name: a['predmet'],
            label: a['predmet'],
          })),
        ],
      };
    case types.FETCH_DISCIPLINES_FAILED:
      return {
        ...state,
        disciplines: initialState.disciplines,
      };
    case types.FETCH_UMK_COMPLETED:
      return {
        ...state,
        umkList: action.payload.UMK,
      };
    case types.FETCH_UMK_FAILED:
      return {
        ...state,
        umkList: initialState.umkList,
      };
    case types.FETCH_UMK_CARD_COMPLETED:
      return {
        ...state,
        umkCard: action.payload.UMK[0] || {},
      };
    case types.FETCH_UMKLIST_DATA_COMPLETED:
      return {
        ...state,
        umkContentData: action.payload,
        umkTypeData: action.typeData,
        isLoading: false
      };
    case types.CLEAR_UMK_DATA:
      return {
        ...state,
        umkContentData: [],
        umkTypeData: false
      };
    default:
      return state;
  }
}
